import ServerPage from 'server/types/ServerPageInterface'
import fixIsMasterBlockRootCommand from 'tools/commands/fixIsMasterBlockRootCommand/fixIsMasterBlockRootCommand'
import fixParentIdCommand from 'tools/commands/fixParentIdCommand'
import migrateAudioCommand from 'tools/commands/migrate/Audio/migrateAudioCommand'
import migrateBulletListCommand from 'tools/commands/migrate/BulletList/migrateBulletListCommand'
import migrationBodyCommand from 'tools/commands/migrate/body/migrate-body-command'
import addQuestionsToCalendar from 'tools/commands/migrate/booking-calendar/add-questions-to-calendar'
import migrateButtonCommand from 'tools/commands/migrate/button/migrate-button-command'
import migrateCheckboxCommand from 'tools/commands/migrate/Checkbox/migrateCheckboxCommand'
import migrateContentBoxCommand from 'tools/commands/migrate/ContentBox/migrateContentBoxCommand'
import migrateCountdownCommand from 'tools/commands/migrate/Countdown/migrateCountdownCommand'
import addHtmlAttrIdToCarouselSubItem from 'tools/commands/migrate/carousel/add-html-attr-id-to-sub-item'
import migrateFullCarouselCommand from 'tools/commands/migrate/carousel/migrateFullCarouselCommand'
import migrateCouponCommand from 'tools/commands/migrate/coupon/migrate-coupon-command'
import { browserMigrateDraftJsToTiptap } from 'tools/commands/migrate/draft-js-to-tiptap/browser-migrate-draftjs-to-tiptap'
import migrateFormInputCommand from 'tools/commands/migrate/FormInput/migrate-form-input-command'
import migrateHorizontalLineCommand from 'tools/commands/migrate/HorizontalLine/migrateHorizontalLineCommand'
import migrateInlineCommand from 'tools/commands/migrate/Inline/migrateInlineCommand'
import migrateImageCommand from 'tools/commands/migrate/image/migrateImageCommand'
import migrateLanguageSwitcherCommand from 'tools/commands/migrate/LanguageSwitcher/migrateLanguageSwitcherCommand'
import migrateMenuCommand from 'tools/commands/migrate/menu/migrateMenuCommand'
import migratePhysicalProductCommand from 'tools/commands/migrate/migratePhysicalProduct/migratePhysicalProductCommand'
import migrateOfferPriceCommand from 'tools/commands/migrate/offerPrice/migrateOfferPriceCommand'
import migratePaymentButtonCommand from 'tools/commands/migrate/paymentButton/migratePaymentButtonCommand'
import migratePaymentMethodCommand from 'tools/commands/migrate/paymentMethod/migratePaymentMethodCommand'
import migrateRawHtmlCommand from 'tools/commands/migrate/RawHtml/migrateRawHtmlCommand'
import migrateContactUsRecaptchaElementCommand from 'tools/commands/migrate/Recaptcha/migrateContactUsRecaptchaElementCommand'
import migrateRowColumnCommand from 'tools/commands/migrate/RowColumnLayout/migrateRowColumnCommand'
import migrateRemotePopupCommand from 'tools/commands/migrate/remote-popup/migrate-remote-popup-command'
import migrateSalesRedirectionButtonCommand from 'tools/commands/migrate/SalesRedirectionButton/migrateSalesRedirectionButtonCommand'
import migrateSectionCommand from 'tools/commands/migrate/Section/migrateSectionCommand'
import migrateTextToTsCommand from 'tools/commands/migrate/text/migrateTextToTsCommand'
import migrateUpsellButtonsCommand from 'tools/commands/migrate/UpsellButton/migrateUpsellButtonsCommand'
import migrateVideoCommand from 'tools/commands/migrate/video/migrateVideoCommand'
import removeDuplicatedBodies from 'tools/commands/remove-duplicated-bodies'
import { removeUnnecessaryFontProperties } from 'tools/commands/remove-unnecessary-font-properties'
import removeDuplicatedEntitiesCommand from 'tools/commands/removeDuplicatedEntitiesCommand'
import removeNonexistentIdFromChildIdsCommand from 'tools/commands/removeNonexistentIdFromChildIdsCommand'
import setParentIdSafeCommand from 'tools/commands/setParentIdSafeCommand'
import migrateAgreementCommand from '../../tools/commands/migrate/Agreement/migrateAgreementCommand'
import migrateOrderBumpCommand from '../../tools/commands/migrate/orderBump/migrate-order-bump-command'
import migratePopupCommand from '../../tools/commands/migrate/popup/migrate-popup-command'

export type MigrationCommand = (page: ServerPage) => [ServerPage, boolean]

// only entity migraion commands excluding non migration-related commands
export const ENTITY_MIGRATIONS_LIST: MigrationCommand[] = [
  // from ts
  migrateRawHtmlCommand,
  migrateCheckboxCommand,
  migrateBulletListCommand,
  migrateCountdownCommand,
  migratePaymentButtonCommand, // @TODO remove from default list
  migrateAgreementCommand,
  migrateInlineCommand,
  migrateRemotePopupCommand,
  migrateButtonCommand,
  migrateFormInputCommand,
  migrationBodyCommand,
  addQuestionsToCalendar,
  addHtmlAttrIdToCarouselSubItem,
  migratePopupCommand, // @TODO return it after QA test
  // from js
  migrateAudioCommand,
  migrateHorizontalLineCommand,
  migrateSalesRedirectionButtonCommand,
  migrateUpsellButtonsCommand, // @TODO remove from default list
  migrateMenuCommand,
  migrateContentBoxCommand,
  migrateLanguageSwitcherCommand,
  migrateContactUsRecaptchaElementCommand,
  migrateRowColumnCommand,
  migrateSectionCommand,
  migrateFullCarouselCommand,
  migrateImageCommand,
  migrateOfferPriceCommand, // @TODO remove from default list
  migratePaymentMethodCommand, // @TODO remove from default list
  migratePhysicalProductCommand, // @TODO remove from default list
  migrateTextToTsCommand,
  migrateVideoCommand,
  migrateOrderBumpCommand, // @TODO remove from default list
  migrateCouponCommand,
  //as the last step
  browserMigrateDraftJsToTiptap,
]

export const DEFAULT_AUTOMIGRATE_COMMAND_LIST: MigrationCommand[] = [
  // fix master blocks and entities
  removeNonexistentIdFromChildIdsCommand,
  removeDuplicatedBodies,
  fixParentIdCommand,
  setParentIdSafeCommand,
  fixIsMasterBlockRootCommand,
  removeDuplicatedEntitiesCommand,
  removeUnnecessaryFontProperties,
  ...ENTITY_MIGRATIONS_LIST,
]
